/**
 * @file surface-fill-labels.ts
 * @description Подписи заливки поверхности (phase19.16, решение 2026-10-11 —
 * дополнение SB8): роли темы для поля `SurfaceFillField` и короткая подпись
 * для сводки группы настроек (SB122): «Плашка», «свой цвет #1F2A44».
 */

import type { SiteFillRole, SiteSurfaceFill } from "@chaiberi/shared";

/** Подписи ролей заливки (шапка, подвал); секция передаёт свои («Как страница»). */
export const FILL_ROLE_LABELS: Readonly<Record<SiteFillRole, string>> = {
  pageBg: "Фон страницы",
  cardBg: "Карточка",
  panelBg: "Плашка",
  darkBg: "Тёмный",
  accent: "Акцент",
};

/** Короткая подпись заливки для сводки группы настроек. */
export function surfaceFillLabel(fill: SiteSurfaceFill, labels: Readonly<Record<SiteFillRole, string>> = FILL_ROLE_LABELS): string {
  return fill.kind === "role" ? labels[fill.role] : `свой цвет ${fill.color}`;
}
